import { observable } from 'mobx';
import { isPortrait } from '@src/js/common/utils';
import { isIpadApp } from '@src/slide/infrastructure/module/dependent/config/tob/enterprise-config';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';


// 默认软键盘高度，e2e没有软键盘，处理下
export const DEFAULT_KEYBOARD_HEIGHT = browser.isE2E ? 290 : 390;
export const DEFAULT_KEYBOARD_MIN_HEIGHT = 190;
const MIN_HEIGHT = 100;
class SoftKeyboardHeightManager {
    /**
     * 计算编辑区域尺寸位置时是否需要避开键盘
     * 这里的【避开】是指计算编辑区域大小位置时需要避开当前键盘的大小
     * 因为在进入焦点时设置了 preventScroll 为 true，所以 ios 中不会自动避开键盘大小，所以 ios 键盘打开时需要设置 isNeedAvoidKeyboard
     * 大部分安卓手机在打开键盘时会挤压页面，也就是键盘位置已经自动避开了，所以不需要设置 isNeedAvoidKeyboard
     */
    @observable
    public isNeedAvoidKeyboard = false;

    // 键盘实际高度
    private height = 0;
    // 当前键盘高度，和键盘打开关闭状态相关
    private currentHeight = 0;

    public setHeight(height: number): void {
        // FIXME：aiFloatManager 内部的 <div role='textbox'> 被点击时会干扰正确的 height，原因未知，暂时屏蔽掉。
        const appServices = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        if (appServices.editableServiceLayer?.aiFloatManager?.isOpen) return;

        this.currentHeight = height;
        // 低于100的都不是正常的软键盘，不予记录
        if (height > MIN_HEIGHT) {
            this.height = height;
        }
    }

    public getCurrentHeight(): number {
        return this.currentHeight;
    }

    public getHeight(): number {
        return this.height || (isPortrait() ? DEFAULT_KEYBOARD_HEIGHT : DEFAULT_KEYBOARD_MIN_HEIGHT);
    }
}

export const softKeyboardHeightManager = new SoftKeyboardHeightManager();

/**
 * 判断是否是在 ipadApp 中正在使用外接键盘
 * 因为 ipad 上外接键盘显示的软键盘高度不固定，所以粗略认为键盘高度小于 100 就是外接键盘
 */
export function isIpadExternalKeyboardOpen(): boolean {
    const currentKeyboardHeight = softKeyboardHeightManager.getCurrentHeight();
    return isIpadApp() && currentKeyboardHeight > 0 && currentKeyboardHeight < 100;
}
